export function itauPayOutgoingPaymentMapper(): { payment_type: 'ewallet'; payment_type_code: 'itau-pay' } {
  return {
    payment_type: 'ewallet',
    payment_type_code: 'itau-pay',
  };
}
